<template>
  <!--表格-->
  <div :style="{ height: wrapperHeight }" v-loading="loading">
    <el-table
      ref="tableData"
      :stripe="stripe"
      :height="height"
      :border="border"
      :max-height="maxHeight"
      header-row-class-name="table-list-header"
      row-class-name="table-list-row"
      :size="tableSize"
      :data="data"
      :lazy="lazy"
      :load="loadFn"
      :row-key="rowKey"
      :tree-props="treeProps"
      @selection-change="handleSelectionChange"
      @current-change="handleTableCurrentChange"
      @row-click="handleTableRowClick"
      v-bind="otherConfig"
    >
      <template v-for="(item, index) in columns">
        <!-- 选择框 -->
        <el-table-column
          v-if="item.selection"
          type="selection"
          width="50"
          :fixed="item.fixed"
          align="center"
          header-align="center"
          :width="item.width ? item.width : ''"
          :key="`selection_${index}`"
        ></el-table-column>
        <!-- 序号 -->
        <el-table-column
          v-else-if="item.index"
          type="index"
          width="80"
          :fixed="item.fixed"
          label="序号"
          :width="item.width ? item.width : ''"
          :index="item.indexMethod"
          :key="`index_${index}`"
        ></el-table-column>
        <!-- 自定义内容 -->
        <slot
          v-else-if="item.slot"
          show-overflow-tooltip
          :name="item.slot"
          :fixed="item.fixed"
          :width="item.width ? item.width : ''"
          :height="item.height"
        ></slot>
        <!-- 常规字段 -->
        <!--v-bind="item"
        :width="item.width"-->
        <el-table-column
          v-else
          show-overflow-tooltip
          :label="item.name"
          :prop="item.key"
          :fixed="item.fixed"
          :width="item.width ? item.width : ''"
          :min-width="item.minWidth || 100"
          :key="`normal_${index}`"
          :formatter="item.formatter"
        ></el-table-column>
      </template>
    </el-table>
    <!-- eslint-disable -->
    <el-pagination
      class="pagination"
      v-if="isPaginationShow && pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[10,20, 30, 50, 100]"
      :current-page.sync="pagination.current"
      :page-size="pagination.size"
      :total="pagination.total"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
    </el-pagination>
    <!-- eslint-enable -->
    <!-- 自定义内容 -->
    <slot name="custom-content"></slot>
  </div>
</template>
<script>
export default {
  name: "Table",
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({
        current: 1,
        size: 20,
        total: 0,
      }),
    },
    isPaginationShow: {
      type: Boolean,
      default: true,
    },
    wrapperHeight: {
      type: [Number, String],
      default: "100%", // table + patination的总高度（父元素高度）
    },
    height: {
      type: [Number, String],
      default: "calc(100% - 48px)", // table的默认高度是 父元素高度 减去 pagination高度
    },
    maxHeight: {
      type: [Number, String],
      default: "auto",
    },
    tableSize: {
      type: String,
      default: "small",
    },
    stripe: {
      type: Boolean,
      default: true,
    },
    otherConfig: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: true,
    },
    // 树形表格
    lazy: {
      type: Boolean,
      default: false,
    },
    loadFn: {
      type: Function,
      default: () => {},
    },
    rowKey: {
      type: String,
      default: "",
    },
    treeProps: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    // 切换页码
    handleCurrentChange() {
      this.$emit("getData");
    },
    // 切换每页条数
    handleSizeChange(value) {
      // current-page和 page-size都支持 .sync修饰符，用了.sync修饰符，就不需要手动给 this.pagination赋值了
      this.pagination.size = value;
      this.$emit("getData");
    },
    // 切换选择
    handleSelectionChange(val) {
      this.$emit("changeSelection", val);
    },
    // 单选
    handleTableCurrentChange(currentRow) {
      this.$emit("changeCurrent", currentRow);
    },
    // 点击行
    handleTableRowClick(currentRow) {
      this.$emit("rowClick", currentRow);
    },
    getTableDom() {
      // this.$nextTick(()=>{
      return this.$refs.tableData;
      // })
    },
  },
  watch: {
    data() {
      // 重新请求数据时 table滚动到顶部
      this.$refs.tableData.$refs.bodyWrapper.scrollTop = 0;
    },
  },
};
</script>
<style scoped lang="less">
.pagination {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
